import Link from 'next/link'
import { memo } from 'react'

import { Image } from '@/shared/ui/Image'

import styles from './basket-item-table.module.scss'

type ProductImageProps = {
	link: string
	title: string
	imageSrc: string
	width: number
	height: number
	isMobile?: boolean
}

/**
 * Компонент изображения товара с ссылкой
 */
export const ProductImage = memo(({ link, title, imageSrc, width, height, isMobile = false }: ProductImageProps) => {
	const className = isMobile ? styles.imageCellMobile : styles.imageCell

	return (
		<div className={className}>
			<Link prefetch={false} href={link} className={styles.imageLink}>
				<Image alt={title} src={imageSrc} placeholder="blur" width={width} height={height} />
			</Link>
		</div>
	)
})
